import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NoteForm } from 'src/app/classes/form-groups/note-form';
import { ToastService } from 'src/app/services/toast.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-confirm-archive-vendor-modal',
  templateUrl: './confirm-archive-vendor-modal.component.html',
  styleUrl: './confirm-archive-vendor-modal.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ConfirmArchiveVendorModalComponent implements OnInit {
  constructor(
    private activeModal: NgbActiveModal,
    private ToastService: ToastService,
    private UtilityService: UtilityService
  ) {}

  @Input() noteTitle?: string;
  @Input() modelType?: 'vendor' | 'company' | 'site' | 'companyVendor';
  @Input() subtitle =
    'The vendor will be hidden from the client. Add a note explaining why.';
  @Input() notePlaceholder =
    'Context the next reviewer needs — supersession, fraud, off-platform, etc.';

  noteForm: NoteForm = new NoteForm();

  close(reason?: string) {
    this.activeModal.dismiss(reason);
  }

  confirm() {
    if (!this.modelType) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Cannot confirm. Missing required note modelType.'
      );
    }

    const formErrors = this.UtilityService.generateValidationErrorsObject(
      this.noteForm
    );

    if (formErrors) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Cannot confirm. Errors in form.'
      );
    }

    const note = this.noteForm.getRawValue();

    Object.assign(note, { modelType: this.modelType });

    this.activeModal.close(note);
  }

  ngOnInit(): void {
    const titleControl = this.noteForm.controls.title;
    const noteControl = this.noteForm.controls.note;

    titleControl.setValue(
      this.noteTitle ? this.noteTitle : `Archived by VIVE Admin`
    );
    titleControl.disable();

    noteControl.setValidators([Validators.required]);
  }
}
